<template>
    <div class="row justify-content-center align-items-center" id="register">
        <div class="col-md-6 col-11">
            <card class="card-signup text-center" no-footer-line>
                <template slot="header">
                    <h4 class="card-title">Forgot Password</h4>
                </template>

                <fg-input
                    v-model="data.email"
                    placeholder="E-Mail"
                    @keyup.enter.native="submit()"/>

                <div class="d-flex justify-content-end">
                    <router-link :to="{ name: 'login' }">
                        <n-button type="neutral">Have account ? Login</n-button>
                    </router-link>
                </div>

                <div class="row">
                    <div class="col-12">
                        <recaptcha
                            :sitekey="$store.state.recaptcha"
                            @verify="onRecaptchaVerify"
                            ref="recaptcha"/>
                    </div>
                </div>

                <div slot="footer">
                    <n-button
                        :loading="loading"
                        class="btn btn-primary btn-round btn-lg"
                        @click.native="submit()">
                            Reset
                    </n-button>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loading: false,
            data: {
                email: '',
                grecaptcha: ''
            }
        }
    },
    methods: {
        submit: async function () {
            this.loading = true
            try {
                await this.$store.dispatch('resetPassword', {
                    data: this.data,
                    host: `${window.location.protocol}//${window.location.host}`
                })
                this.$notify({ type: 'success', message: 'Reset instructions were sent to your email.' })
            } catch (e) {
                this.$refs.recaptcha.reset()
                console.log('error on submitting password reset')
            }
            this.loading = false
        },
        onRecaptchaVerify: function (grecaptcha) {
            this.data.grecaptcha = grecaptcha
        }
    }
}
</script>